import React, { Fragment } from 'react'
import moment from '../utils/momentTimeZone'
import tachyon from '../utils/tachyon'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AriaTooltips from './AriaTooltips';

const InstanceBookingButton = (instance) => {
    if (instance.showBookingButton) {
        if (instance.soldOut) {
            return (
                <Fragment>
                    <span className="c-btn c-btn--disabled c-btn--ghost c-btn--small">
                        <Time datetime={instance.postDate} eventTypes={instance.eventTypes} calendarBookingLabel={instance.calendarBookingLabel || ''} /> 
                        <span className="c-time-slot__sold-out-label">Sold out</span>
                    </span>
                </Fragment>
            )
        }

        return (
            <Fragment>
                {instance.limitedAvailability
                    ? <span className="c-time-slot__limited-label c-small-label">Limited Tickets</span>
                    : ''}
                <a href={instance.bookingUrl} className="c-btn c-btn--red c-btn--ghost c-btn--small">
                    <span className="u-hidden-visually">
                        Book tickets for <Time datetime={instance.postDate} eventTypes={instance.eventTypes} calendarBookingLabel={instance.calendarBookingLabel || ''} />
                    </span>
                    <span aria-hidden="true">
                        <Time datetime={instance.postDate} eventTypes={instance.eventTypes} calendarBookingLabel={instance.calendarBookingLabel || ''} />
                    </span>
                    <i className="far fa-angle-right"></i>
                </a>
            </Fragment>
        )
    }

    return (
        <Fragment>
            <span className="c-btn c-btn--disabled c-btn--ghost c-btn--small">Coming soon <i className="far fa-angle-right"></i></span>
        </Fragment>
    )
}

const Time = ({ datetime, eventTypes, calendarBookingLabel }) => {

    const mTime = moment.unix(datetime)
    const formattedTime = mTime.format('h.mm A')

    if (calendarBookingLabel) {
        return (
            <Fragment>
                {calendarBookingLabel}
            </Fragment>
        )
    }

    // Special case for online performances
    if (eventTypes && eventTypes.includes('Online performances')) {
        return (
            <Fragment>
                Watch
            </Fragment>
        )
    }

    if (formattedTime === '12.00 AM') {
        return (
            <Fragment>
                {mTime.format('h.mm')} <span class="c-am-pm__text">Midnight</span>
            </Fragment>
        )
    }

    if (formattedTime === '12.00 PM') {
        return (
            <Fragment>
                {mTime.format('h.mm')} <span class="c-am-pm__text">Noon</span>
            </Fragment>
        )
    }

    return (
        <Fragment>
            {mTime.format('h.mm')} <span class="c-am-pm__text">{mTime.format('A')}</span>
        </Fragment>
    )

}

const EventCalendarListing = ({ hit }) =>  {
    return (                
        <div key={hit.postId} className="c-day-event">
            {hit.coverUrl &&
            <a className="c-day-event__link" href={hit.permalink}>
                <figure className="fig c-day-event__img">
                    <LazyLoadImage alt={hit.postTitle} src={tachyon.fetch(hit.coverUrl, { resize: '240,110', gravity: 'center' })} height={55} width={120}
                        placeholderSrc={tachyon.fetch(hit.coverUrl, { resize: '24,11', gravity: 'center' })} />
                </figure>
            </a>
            }
            <div className="c-day-event__body">
                <div className="c-day-event__details">
                    <a className="c-day-event__link" href={hit.permalink}>
                        <h5 className="c-day-event__title">{hit.postTitle}</h5>
                    </a>
                    <span className="c-day-event__meta c-day-event__type" dangerouslySetInnerHTML={{ __html: (hit.eventTypes || []).join(', ') }}></span>
                    { hit.venue &&
                    <div className="c-event-card__meta c-event-card__venue">
                        <span key={hit.venue}><i className="fal fa-map-marker-alt"></i>&nbsp;{hit.venue}</span>
                    </div>
                    }
                </div>
                <div className="c-day-event__timeslots">
                    
                    <div key={`${hit.objectID}`} className="c-time-slot">
                        <div className="c-time-slot__details">
                            <AriaTooltips access={hit.access || []} />
                            { hit.note && hit.note !== ''  &&
                            <span className="c-time-slot__notes" dangerouslySetInnerHTML={{ __html: hit.note }} />
                            }
                        </div>
                        <div>{InstanceBookingButton(hit)}</div>
                        {!hit.soldOut 
                            ? <span className="c-event-card__meta c-event-card__price-label">{hit.priceLabel}</span> 
                            : ''}
                    </div>
                </div>
            </div>
        </div>    
    )
};

export default EventCalendarListing;



// WEBPACK FOOTER //
// ./src/whatson/components/EventCalendarListing.js